import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, Clock, XCircle, Loader2, Package } from "lucide-react";
import { useStore } from "./StoreShell";
import { StoreHeader } from "../../components/market/StoreHeader";
import { mk, money, ORDER_LABELS } from "../../lib/marketApi";

export const OrderItems = ({ o, cur }) => (
  <div className="space-y-2">
    {o.items.map((it) => (
      <div key={it.product_id} className="flex items-center gap-3 text-sm">
        {it.image && <img src={it.image} alt="" className="h-10 w-10 rounded-lg object-cover" />}
        <span className="min-w-0 flex-1 truncate">{it.qty} × {it.name}</span>
        <span className="font-medium">{money(it.total, cur)}</span>
      </div>
    ))}
    <div className="flex justify-between border-t border-black/5 pt-2 text-sm opacity-70"><span>Envío</span><span>{o.shipping ? money(o.shipping, cur) : "Gratis"}</span></div>
    <div className="flex justify-between font-bold"><span>Total</span><span>{money(o.total, cur)}</span></div>
  </div>
);

export default function OrderPage() {
  const { oid } = useParams();
  const { slug, store, buyer, clearCart, setAuthOpen } = useStore();
  const [o, setO] = useState(null);
  const [err, setErr] = useState("");
  const tries = useRef(0);
  const cleared = useRef(false);

  useEffect(() => {
    if (!buyer) return setAuthOpen(true);
    let timer;
    const poll = async () => {
      try {
        const d = await mk(`/s/${slug}/orders/${oid}`, { token: buyer.token });
        setO(d);
        if (d.payment_status === "paid" && !cleared.current) {
          cleared.current = true;
          clearCart();
        }
        if (d.payment_status === "pending" && tries.current++ < 8) timer = setTimeout(poll, 2500);
      } catch (e) {
        setErr(e.message);
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [buyer, oid, slug]); // eslint-disable-line react-hooks/exhaustive-deps

  const paid = o?.payment_status === "paid";
  const Icon = !o ? Loader2 : paid ? CheckCircle2 : o.payment_status === "pending" ? Clock : XCircle;
  return (
    <>
      <StoreHeader />
      <main className="mx-auto max-w-lg px-4 py-10">
        <div className="p-6 text-center" style={{ background: "var(--mk-surface)", borderRadius: "var(--mk-radius)" }} data-testid="order-page">
          <Icon className={`mx-auto h-14 w-14 ${!o ? "animate-spin opacity-40" : ""}`} style={{ color: paid ? "#16a34a" : "var(--mk-primary)" }} />
          <h1 className="mt-3 text-xl font-bold" data-testid="order-status-title">
            {err ? err : !o ? "Confirmando tu pago…" : paid ? "¡Gracias por tu compra!" : o.payment_status === "pending" ? "Esperando confirmación del pago" : "El pago no se completó"}
          </h1>
          {o && <p className="mt-1 text-sm opacity-60">Pedido #{o.number} · {ORDER_LABELS[o.status]}</p>}
          {o && <div className="mt-6 text-left"><OrderItems o={o} cur={store.currency} /></div>}
          <div className="mt-6 flex flex-col gap-2">
            <Link to={`/m/${slug}/mis-pedidos`} className="inline-flex items-center justify-center gap-2 rounded-full py-3 text-sm font-semibold text-white" style={{ background: "var(--mk-primary)", color: "var(--mk-on-primary)" }} data-testid="order-my-orders">
              <Package className="h-4 w-4" /> Mis pedidos
            </Link>
            <Link to={`/m/${slug}`} className="py-2 text-sm opacity-70" data-testid="order-continue">Seguir comprando</Link>
          </div>
        </div>
      </main>
    </>
  );
}
